<script>
  import { resolveLogo } from './logo'
  import { isVideo } from './util'

  export let lenke

  $: kategori = lenke.kategorier[0]

  $: logo = resolveLogo(lenke)

  $: video = isVideo(lenke)
</script>

<style>
  .kategori {
    font-size: 13px;
    text-transform: uppercase;
    padding-left: 6px;
    position: relative;
  }

  .kategori::before {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 100%;
    border-radius: 10px 1px 10px 1px;
    background: var(--color-theme);
  }

  .logo {
    font-size: 14px;
  }

  .sr {
    position: absolute !important;
    overflow: hidden !important;
    width: 1px !important;
    height: 1px !important;
    clip: rect(0, 0, 0, 0) !important;
  }

  .video {
    position: relative;
    margin-left: 10px;
  }

  .video::after {
    position: absolute;
    content: '|';
    left: -9px;
    top: 50%;
    transform: translateY(-50%);
    color: #4a4a4a;
  }

  .small {
    font-size: 11px;
  }
</style>

{#if logo}
  <span class="logo">
    {@html logo}
  </span>
{:else if kategori}
  <span
    class="kategori"
    style="--color-theme: var(--{kategori.fargetema})"
    class:small={lenke.visning === 'vertikal-enkel' && kategori.kortnavn === 'Underholdning' && video}>
    <span class="sr">Kategori:</span>
    {kategori.kortnavn}
    {#if video}<span class="video">video</span>{/if}
  </span>
{/if}
